import request from '@/util/request';
import qs from 'qs';

export const getAclList = (params, options) =>
request.get('/mqtt/acl/page', Object.assign({}, options, { params }));

export const addAcl = (params, options) =>
request.post('/mqtt/acl/add', params,options);

export const getAclDetail = (params, options) =>
request.get('/mqtt/acl/detail', Object.assign({}, options, { params }));

export const removeAcl = (params, options) =>
request.post('/mqtt/acl/remove', qs.stringify(params),options);


export const updateAcl = (params, options) =>
request.post('/mqtt/acl/update', params,options);
